import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import useSelectedInstitution from 'utils/hooks/institutions/useSelectedInstitution';
import { notifySuccess } from 'utils/notifications';

import {
  closeObligationsResettingModal,
  openObligationsResettingModal,
  setChosenUserToSet,
  setDeleteUserConfirmation
} from 'store/entities/users';

import {
  deleteReporter,
  getInstitutionUsersList,
  setReporterToObligations,
} from 'store/entities/users/thunks';

import ConfirmationModal from 'components/UIComponents/Modal/ConfirmationModal';
import Button from "components/UIComponents/Button";
import Modal from "components/UIComponents/Modal";
import { ModalCard } from "components/UIComponents/Modal/ModalCard";
import { Section } from "components/UIComponents/Layout/Section";
import { Select } from "components/UIComponents/Form/Select";
import { Row } from 'components/UIComponents/Layout/Row';


export default () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { institutionId } = useSelectedInstitution();
  const {
    deleteUserConfirmation,
    deleteReporterSubmitting,
    resetObligationsModalOpen,
    users,
    setReporterToObligationsSubmitting,
    obligationsToReset,
    chosenUserToSet
  } = useSelector(
    state => state.users
  );

  const userHasObligiations = deleteUserConfirmation?.value?.reporterObligations?.length !== 0;

  const onSubmit = () => {
    if (userHasObligiations) {
      dispatch(openObligationsResettingModal(deleteUserConfirmation.value.reporterObligations));
    } else {
      onConfirm();
    }
  };

  const onConfirm = async () => {
      const deleteResult = await dispatch(
          deleteReporter({
            institutionId,
            userId: deleteUserConfirmation?.value.publicUserDto.id,
          })
      );
      if (deleteReporter.fulfilled.match(deleteResult)) {
        notifySuccess(t('datagate.external.users.message.deleteReporter'));
        dispatch(setDeleteUserConfirmation({open: false}));
        dispatch(getInstitutionUsersList(institutionId));
      }
  }

  const resetObligationToAnotherReporterAndConfirmRemove = async () => {
    const resettingResult = await dispatch(setReporterToObligations({
      institutionId,
      reporterId: chosenUserToSet.id,
      obligations: obligationsToReset
    }))
    if (setReporterToObligations.fulfilled.match(resettingResult)) {
      dispatch(closeObligationsResettingModal());
      onConfirm();
    }
  }

  return (
    <ConfirmationModal
      title={t('datagate.external.global.confirmChoice')}
      open={deleteUserConfirmation?.open}
      onCancel={() => dispatch(setDeleteUserConfirmation({ open: false }))}
      onConfirm={onSubmit}
      loading={deleteReporterSubmitting}
      confirmText={t('datagate.external.global.confirm')}
      cancelText={t('datagate.external.global.cancel')}
    >
      <Row>
        <p>
          {t('datagate.external.users.message.deleteReporterConfirmation', {
            firstName: deleteUserConfirmation?.value?.publicUserDto.firstName,
            lastName: deleteUserConfirmation?.value?.publicUserDto.lastName,
            idCode: deleteUserConfirmation?.value?.publicUserDto.idCode,
          })}
        </p>
      </Row>

      <Modal
          show={resetObligationsModalOpen}
          onClose={() => {
            dispatch(closeObligationsResettingModal())
          }}
      >
        <ModalCard>
          <ModalCard.Head>
            <ModalCard.Title>
              {t('datagate.external.users.modal.obligationsResetting.heading')}
            </ModalCard.Title>
          </ModalCard.Head>
          <ModalCard.Body>
            {userHasObligiations && <Section className="vertical-padding-md pt-5 pb-5">
              <p>
                {t('datagate.external.users.modal.obligationsResetting.select.infoText')}
              </p>
              {obligationsToReset.map(obligation => (<li key={obligation.id}>{`#${obligation.id} ${obligation.obligationTableName}`}</li>))}
              <Select
                  placeholder={t('datagate.external.users.modal.obligationsResetting.select.placeholder')}
                  disabled={setReporterToObligationsSubmitting}
                  options={users.filter(user => user.publicUserDto.id !== deleteUserConfirmation?.value?.publicUserDto.id)}
                  getOptionLabel={option => `${option.publicUserDto.firstName} ${option.publicUserDto.lastName}`}
                  getOptionValue={option => option}
                  onChange={value => dispatch(setChosenUserToSet(value.publicUserDto))}
              />
            </Section>}
          </ModalCard.Body>
          <ModalCard.Foot className="margin-bottom-extra">
            <Button
                type="button"
                color="primary"
                onClick={() => {
                  dispatch(closeObligationsResettingModal())
                }}
                outlined
            >
              &#215; {t('datagate.external.global.cancel')}
            </Button>
            <Button
                type="button"
                color="primary"
                disabled={setReporterToObligationsSubmitting || chosenUserToSet === null}
                id="confirmUserAdditionButton"
                onClick={() => resetObligationToAnotherReporterAndConfirmRemove()}
            >
              {t('datagate.external.global.confirm')}
            </Button>
          </ModalCard.Foot>
        </ModalCard>
      </Modal>

    </ConfirmationModal>
  );
};
